import { db } from "@/db";

export function sendAdminProjectNotification(developerId, project, message) {
  return db
    .collection("UserNotifications")
    .doc(developerId)
    .collection("Notifications")
    .add({
      type: "adminMessage",
      message: message.trim(),
      projectId: project.gameId,
      projectName: project.gameName,
      projectImg: project.img || null,
      timestamp: new Date(),
      unread: true,
    });
}

export async function sendAdminAnnouncement(adminId, announcementText) {
  const text = (announcementText || "").trim();
  if (!text) {
    return { success: false, error: "Announcement cannot be empty" };
  }

  const usersSnapshot = await db.collection("User").get();
  const timestamp = new Date();
  const recipients = usersSnapshot.docs.filter(userDoc => userDoc.id !== adminId);

  let successCount = 0;
  let errorCount = 0;

  await Promise.all(
    recipients.map(async userDoc => {
      try {
        await db
          .collection("UserNotifications")
          .doc(userDoc.id)
          .collection("Notifications")
          .add({
            type: "announcement",
            message: text,
            timestamp,
            unread: true,
          });
        successCount++;
      } catch (error) {
        console.error(`Error sending announcement to user ${userDoc.id}:`, error);
        errorCount++;
      }
    })
  );

  return {
    success: errorCount === 0,
    data: { totalUsers: recipients.length, successCount, errorCount, timestamp },
  };
}

/**
 * Subscribe to Firestore notifications for testers & developers
 */
export function subscribeTesDevNotifications(userId, onAdd, onRemove) {
  return db
    .collection("UserNotifications")
    .doc(userId)
    .collection("Notifications")
    .orderBy("timestamp", "asc")
    .onSnapshot(snapshot => {
      snapshot.docChanges().forEach(change => {
        const data = change.doc.data();

        const payload = {
          ...data,
          firebaseId: change.doc.id,
          timestamp:
            data.timestamp && typeof data.timestamp.toDate === "function"
              ? data.timestamp.toDate()
              : new Date(data.timestamp),
        };

        if (change.type === "added") onAdd(payload);
        if (change.type === "removed") onRemove(change.doc.id);
      });
    });
}



// WEBPACK FOOTER //
// ./src/Firestore/NotificationDevTes.js